import { FC } from "react";
import { Badge } from "@chakra-ui/react";

import { EVAL_RUN_STATUS } from "@shared/models";

const statusConfig = {
  [EVAL_RUN_STATUS.RUNNING]: { title: "Running", variant: "subtle" },
  [EVAL_RUN_STATUS.COMPLETED]: { title: "Completed", variant: "success" },
  [EVAL_RUN_STATUS.FAILED]: { title: "Failed", variant: "danger" },
} as const;

const EvalRunStatusBadge: FC<{ status: EVAL_RUN_STATUS }> = ({ status }) => (
  <Badge variant={statusConfig[status].variant} w="max-content" whiteSpace="nowrap">
    {statusConfig[status].title}
  </Badge>
);

export default EvalRunStatusBadge;
